import styled from '@emotion/styled'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import GainCompleteViewOfYourCustomersImage from './GainCompleteViewOfYourCustomersImage'

const copy = {
  heading: `Gain a complete view of your customers`,
  description: `Get complete, identity-resolved customer profiles in real time and easily build precise audiences in a privacy-first way to deliver personalized customer experiences at scale.`,
}

const link = {
  text: `Explore Unify`,
  url: `/product/unify/`,
}

const features = [
  {
    heading: `Build dynamic audiences off of real-time complete profiles`,
    description: `Craft audiences without SQL expertise, with real-time customer interactions including behaviors, traits, and intent signals.`,
  },
  {
    heading: `Know your customer in a privacy-first way`,
    description: `Profiles are built with consented data collection and activation for privacy-first personalization across channels.`,
  },
  {
    heading: `Discover new engagement opportunities`,
    description: `Identify new customer insights and behavioral patterns to uncover untapped opportunities for engagement in real time.`,
  },
]

const GainCompleteViewOfYourCustomers = () => {
  const pageConfig = usePageConfig()

  return (
    <SectionWrapper variant="2Col" reverse={true}>
      <StyledSectionCopy>
        <CopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description>{copy.description}</CopyText.Description>
        </CopyTextBase>

        <ColumnTrackWrapper>
          <ColumnTrack gap="small">
            {features.map((feature, index) => (
              <FeatureBoxBase key={index} alignment="left">
                <FeatureBox.Body>
                  <FeatureBox.Title>{feature.heading}</FeatureBox.Title>
                  <FeatureBox.Text>{feature.description}</FeatureBox.Text>
                </FeatureBox.Body>
              </FeatureBoxBase>
            ))}
          </ColumnTrack>
        </ColumnTrackWrapper>
        <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
      </StyledSectionCopy>

      <Section.Contents>
        <GainCompleteViewOfYourCustomersImage />
      </Section.Contents>
    </SectionWrapper>
  )
}

const SectionWrapper = styled(SectionBase)`
  overflow-x: visible;
`

const StyledSectionCopy = styled(Section.Copy)`
  direction: ltr;
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    justify-self: end;
    max-width: 440px;
  }
`

const ColumnTrackWrapper = styled.div`
  margin-top: 40px;
`

export default GainCompleteViewOfYourCustomers
